import { UIComponentCSSStyleImpl, UIComponentCSSStyle } from '../../uicomponentcss';
import { Colors } from '../../../../utils/resources/colors';

export interface SearchBoxCSSStyle extends UIComponentCSSStyle
{
    getMainDivCSSStyle():object;
    getMobileMainDivCSSStyle():object;
    getSearchBoxImageDivCSSStyle():object;
    getSearchBoxInputDivCSSStyle():object;
    getSearchLabelCSSStyle():object;
    getMobileSearchLabelCSSStyle():object;
    getMobileSearchBoxImageDivCSSStyle():object;
    getMobileSearchBoxInputDivCSSStyle():object;

}
export class SearchBoxCSSStyleImpl extends UIComponentCSSStyleImpl implements SearchBoxCSSStyle
{
    getMainDivCSSStyle(): object 
    {
        return{
            borderRadius:'30px',backgroundColor:this.getResources().getColor(Colors.color_5),
            border:'1px solid'+this.getResources().getColor(Colors.color_8),
        };
    }    

    getMobileMainDivCSSStyle(): object 
    {
        return{
            borderRadius:'30px',backgroundColor:this.getResources().getColor(Colors.color_5),
            border:'1px solid'+this.getResources().getColor(Colors.color_8),
        };
    }  
    getSearchBoxImageDivCSSStyle(): object {
        return{
            width:"140px", 
            height:"100%",
            backgroundColor:this.getResources().getColor(Colors.color_16), 
            float:'right',
            borderRadius:'0px 30px 30px 0px',
            cursor: "pointer"
        };
    }

    getSearchLabelCSSStyle():object
    {
        return{
            color:this.getResources().getColor(Colors.color_4),
            textAlign:'center',
            cursor: "pointer"
        };
    }
    getMobileSearchLabelCSSStyle():object
    {
        return{
            width:'100%',height:'20px',lineHeight:'16px',marginTop:'10px',fontSize:'15px',fontWeight:600,
            color:this.getResources().getColor(Colors.color_4),
            textAlign:'center',
            cursor: "pointer",
            padding:'2px 10px 0px 10px'
        };
    }
    getSearchBoxInputDivCSSStyle(): object 
    {
        return{
            flex: 1,height:'100%', paddingTop:'11px', lineHeight:'20px', paddingBottom:'10px',
            marginLeft:'30px', marginRight:'10px',outline:'none',border:'none',
            // fontSize:this.getResources().getFont(Fonts.h10),
            fontWeight: 300,
            letterSpacing: 0,
            focus:'none',
            color:this.getResources().getColor(Colors.color_9),
            fontFamily: this.getResources().getFontFamily(),
            backgroundColor:this.getResources().getColor(Colors.color_5),
        };
    }
    getMobileSearchBoxInputDivCSSStyle(): object 
    {
        return{
            flex: 1,height:'100%', paddingTop:'11px', lineHeight:'20px', paddingBottom:'10px',
            marginLeft:'20px', marginRight:'10px',outline:'none',border:'none',
            fontSize:"15px",
            fontWeight: 300,
            letterSpacing: 0,
            focus:'none',
            color:this.getResources().getColor(Colors.color_9),
            fontFamily: this.getResources().getFontFamily(),
            backgroundColor:this.getResources().getColor(Colors.color_5),
        };
    }
    getMobileSearchBoxImageDivCSSStyle(): object {
        return{
            width:"140px", height:"100%",
            backgroundColor:this.getResources().getColor(Colors.color_16), 
            float:'right',
            borderRadius:'0px 30px 30px 0px',
            cursor: "pointer",
            padding:'0px 10px 0px 10px'
        };
    }


  
  
    
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbarwithsearch/searchbox/searchboxcss.tsx